import React, { ComponentProps } from 'react';

import { Text } from '../Text';

type Props = Partial<
  Pick<ComponentProps<typeof Text>, 'color' | 'fontSize' | 'fontWeight'>
>;

export const Dash = ({
  color = 'grey-dark',
  fontSize = 14,
  fontWeight,
}: Props = {}) => (
  <Text as="span" color={color} fontSize={fontSize} fontWeight={fontWeight}>
    -
  </Text>
);
